import {
  ClientType,
  OnboardingBiography,
} from 'modules/onboarding/common/components';

import { useOwnerBiography } from '../hooks';
import { PageComponentProps } from '../types';

export const OwnerBiographyStep = ({ canGoBack }: PageComponentProps) => {
  const { goToBack, initialValues, onSubmit, submitLoading } =
    useOwnerBiography();

  return (
    <OnboardingBiography
      canGoBack={canGoBack}
      clientType={ClientType.Client}
      initialValues={initialValues}
      submitLoading={submitLoading}
      onGoBack={goToBack}
      onSubmit={onSubmit}
    />
  );
};
